import { render, staticRenderFns } from "./MoveToFixedFlow.vue?vue&type=template&id=48ea28f1"
import script from "./MoveToFixedFlow.vue?vue&type=script&lang=js"
export * from "./MoveToFixedFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports